if ((typeof Shopify) === 'undefined') {
  Shopify = {};
}

Shopify.onError = function(t, r) {
  var e = eval("(" + t.responseText + ")");
  e.message ? alert(e.message + "(" + e.status + "): " + e.description) : alert("Error : " + Shopify.fullMessagesFromErrors(e).join("; ") + ".")
};

Shopify.fullMessagesFromErrors = function(t) {
  var r = [];
  return jQuery.each(t, function(t, e) {
    jQuery.each(e, function(e, a) {
      r.push(t + " " + a)
    })
  }),
  r
};


Shopify.addItem = function(variant_id, qty, properties, callback) {
  var qty = qty || 1;
  var params = {
    quantity: qty,
    id: variant_id
  }
  if(properties != false){
    params.properties = properties;
  }
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: params,
    dataType: "json",
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        Shopify.onItemAdded(line_item);
        // maybe move Shopify.onItemAdded to run after queue is clear???

        callback(line_item);
      } else {
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  });
};

Shopify.onItemAdded = function(line_item) {
//   console.log(line_item.title + " was added to your shopping cart.");
  Shopify.getCart();
};

Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      Shopify.onCartUpdate(cart);
    }
  });
};

Shopify.onCartUpdate = function(t) {
    console.log("There are now " + t.item_count + " items in the cart.")
}
